import { PublicEmptyLegFilters } from './types'

export const createEmptyPublicEmptyLegFilters = (): PublicEmptyLegFilters => ({
    from: '',
    destination: '',
    from_location: null,
    destination_location: null,
    dates: null,
})

export const hasPublicEmptyLegSearchCriteria = (filters: PublicEmptyLegFilters) => Boolean(
    filters.from
    || filters.destination
    || filters.from_location
    || filters.destination_location
    || filters.dates,
)
